import styled from 'styled-components';

export const Container = styled.div<{ cover: string }>`
  border-radius: 15px;
  min-height: 350px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  padding: 15px 15px 25px;
  background: url(${({ cover }) => cover}) no-repeat center center / cover;
  gap: 12px;
`;

export const HotelLogoWrapper = styled.div`
    height: 80px;
    width: 80px;
    border-radius: 15px;
    overflow: hidden; 
    display: flex;
    box-sizing: border-box;
 
    `;
export const HotelLogo = styled.img`
  width: 100%;
  height: 100%;
`;

export const Title = styled.span`
  color: #ffffff;
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
  margin-top: 200px;
`;

export const Description = styled.span`
  color: #ffffff;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
`;

export const LabelsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
`;

export const Label = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  border-radius: 10px;
  padding: 5px 15px;
  background-color: rgba(0,0,0,0.5);
  border: 1px solid #FFF;
`;

export const LabelText = styled.span`
  color: #ffffff;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 400;
`;

export const LabelIcon = styled.img`
  width: 14px;
  height: 14px;
`;
